import {
  CampaignType,
  Channels,
  OpeningMessageMode
} from 'generated-graphql/types';
// TODO: Fix this type
import { ClosingMethod } from 'services/campaign/types';
import Yup from 'utils/validation';
import { getCampaignCreationSMSValidation } from 'modules/campaign-creation/utils/getCampaignCreationSMSValidation';
import { getCampaignCreationEmailValidation } from 'modules/campaign-creation/utils/getCampaignCreationEmailValidation';
import { getCampaignCreationWhatsAppValidation } from 'modules/campaign-creation/utils/getCampaignCreationWhatsAppValidation';

type GetCampaignCreationSetupValidationSchemaProps = {
  campaignType: CampaignType;
  channel: Channels;
  openingMessageMode: OpeningMessageMode | undefined;
};

// NOTE: This is required for the typing
const getInitialValidationObject = () => {
  const validationObject = {
    // NOTE: These can be overridden by the channel validation
    templateId: Yup.string().nullable().optional(),
    customTemplatedMessage: Yup.string().nullable().optional(),
    customTemplatedMessageCharactersCount: Yup.number().nullable().optional(),
    customTemplatedSubjectLine: Yup.string().nullable().optional(),
    // NOTE: This cannot be overridden by the channel validation
    agentName: Yup.string().required('The agent name is required'),
    closingMethod: Yup.string()
      .required('This field is required')
      .test('closingMethod', 'This field is required', function (value) {
        if (
          value !== ClosingMethod.CUSTOM &&
          value !== ClosingMethod.CALENDAR_MEETING_INTEGRATION
        ) {
          return false;
        } else {
          return true;
        }
      }),
    customRequest: Yup.string().test(
      'customRequest',
      'This field is required',
      function (value) {
        if (this.parent.closingMethod === ClosingMethod.CUSTOM) {
          return value !== undefined;
        } else {
          return true;
        }
      }
    ),
    calendarMeetingTemplateId: Yup.string().test(
      'calendarMeetingTemplateId',
      'This field is required',
      function (value) {
        if (
          this.parent.closingMethod ===
          ClosingMethod.CALENDAR_MEETING_INTEGRATION
        ) {
          return value !== undefined;
        } else {
          return true;
        }
      }
    ),
    rejectionMessage: Yup.string().optional(),
    closingMessage: Yup.string().optional(),
    timeToAutoCloseConversationsInHours: Yup.number()
      .positive('Must be a positive number')
      .integer('Must be a whole number')
      .required('This field is required'),
    agentId: Yup.string().nullable(),
    agentTone: Yup.string().optional()
  };

  return validationObject;
};

export type GetCampaignInitialValidationObject = ReturnType<
  typeof getInitialValidationObject
>;

export const getCampaignCreationSetupValidationSchema = ({
  campaignType,
  channel,
  openingMessageMode
}: GetCampaignCreationSetupValidationSchemaProps): Yup.ObjectSchema<any> => {
  const validationObject = getInitialValidationObject();

  switch (channel) {
    case Channels.Sms:
      return getCampaignCreationSMSValidation({
        campaignType,
        openingMessageMode,
        validationObject
      });
    case Channels.Email:
      return getCampaignCreationEmailValidation({
        campaignType,
        validationObject
      });
    case Channels.Whatsapp:
      return getCampaignCreationWhatsAppValidation({
        validationObject
      });
    default:
      return Yup.object().shape(validationObject);
  }
};
